export default "__VITE_ASSET__4543d800__"